export const getFocusableElements = (container) => {
  const focusableSelector = 'a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), input:not([disabled]):not([tabindex="-1"]), select:not([disabled]):not([tabindex="-1"]), textarea:not([disabled]):not([tabindex="-1"]), [tabindex]:not([disabled]):not([tabindex="-1"])';
  const focusableElements = container.querySelectorAll(focusableSelector);
  const focusableElementsArray = Array.from(focusableElements);
  return focusableElementsArray;
};

export default {};